export const ArrowUp = ({ className = '' }) => {
  return (
    <img
      src='/assets/icons/sidebar/arrow-up.svg'
      alt='scroll to top'
      className={className}
    />
  )
}
